export default __webpack_public_path__ + "static/media/customer-card.9925572c.svg";